import { Language } from '@shared/modules/translation/index';
import { useTranslation } from 'react-i18next';

export function useCurrentLanguage(): Language {
  const { i18n } = useTranslation();

  return i18n.language.startsWith('en') ? 'en' : 'fr';
}
